import { Progress as ArkProgress } from "@ark-ui/react/progress";

import { CircularProgress } from "./CircularProgress";
import { LinearProgress } from "./LinearProgress";
import { ProgressValueText } from "./ProgressValueText";

export type { ProgressSelectValueDetails } from "./LinearProgress";

export const Progress = {
  Linear: LinearProgress,
  Label: ArkProgress.Label,
  Circular: CircularProgress,
  ValueText: ProgressValueText,
};
